import { FC } from 'react'

import { useUnsafeEffect } from '@factorialco/deprecated-design-system'
import { SelectableLocationsDocument } from 'generated/resources/graphql'

import MultipleChoice from 'modules/core/components/Filter/filters/MultipleChoice'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

interface Props {
  defaultOpen?: boolean
  defaultLabel?: string
  defaultLocationIds?: number[]
  selectedLocationIds?: number[]
  onChangeLocationIds: (value?: number[]) => void
  composeActiveLabel?: (value: number[]) => string
}

export const LocationSelector: FC<Props> = ({
  defaultOpen,
  defaultLabel,
  defaultLocationIds,
  composeActiveLabel,
  selectedLocationIds,
  onChangeLocationIds,
}) => {
  const { data: dataLocations } = useQuery(SelectableLocationsDocument, {
    variables: {
      employeeIds: [],
    },
  })

  const options = useUnsafeMemo(() => {
    return (
      dataLocations?.locations.locations.map(({ id, name }) => ({
        value: id,
        label: name,
      })) || []
    )
  }, [dataLocations])

  const selectedValues = selectedLocationIds
    ?.map((i) => options.find((option) => option.value === i)?.value)
    .filter((i) => i !== undefined)

  // set default value as current value if there is no current value
  useUnsafeEffect(() => {
    if (defaultLocationIds?.length && !selectedLocationIds?.length && options?.length) {
      onChangeLocationIds(
        defaultLocationIds.filter((id) => options.find((option) => option.value === id)?.value)
      )
    }
  }, [options, onChangeLocationIds, defaultLocationIds, selectedLocationIds])

  return (
    <MultipleChoice
      options={options}
      value={selectedValues}
      defaultOpen={defaultOpen}
      onValueChange={onChangeLocationIds}
      label={defaultLabel || i18n.t('settings.locations.title')}
      composeActiveLabel={
        composeActiveLabel ? () => composeActiveLabel(selectedValues || []) : undefined
      }
    />
  )
}
